<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>评论列表</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="订单号" prop="orderNo">
                <el-input v-model="formInline.orderNo" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="username">
                <el-input v-model="formInline.username" placeholder="手机号"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中" :default-sort="{prop: 'status'}">
            <el-table-column prop="id" label="ID">
            </el-table-column>
            <el-table-column prop="orderInfo.orderNo" label="订单号">
            </el-table-column>
            <el-table-column prop="userManage.nickName" label="用户昵称">
            </el-table-column>
            <el-table-column prop="userInfo.username" label="手机号">
            </el-table-column>
            <el-table-column prop="productObj.name" label="设备名称">
            </el-table-column>
            <el-table-column prop="content" label="评价内容">
            </el-table-column>
            <el-table-column inline-template :context="_self" prop="created" label="评价时间">
                <span  v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column inline-template :context="_self" label="状态" sortable prop="status">
                <div>
                    <span v-if="row.status === 1">审核通过</span>
                    <span v-if="row.status === 2">审核不通过</span>
                    <span v-if="row.status === 0 || row.status === null">待审核</span>
                </div>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                                                                    <el-button @click="handleCheck($index, row)" type="text" size="small" v-if="row.status === 0 || row.status === null">审核</el-button>
                                                                    <el-button @click="handleView($index, row)" type="text" size="small">查看</el-button>
                                                                    <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="Role === '1'">删除</el-button>
                                                        </span>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>

        <el-dialog title="查看评论详情" :visible.sync="dialogFormVisible" size="large">
            <el-form :model="form">
                <el-form-item label="订单号：" label-width="150px">
                    <span v-if="form.orderInfo">{{form.orderInfo.orderNo}}</span>
                </el-form-item>
                <el-form-item label="用户昵称：" label-width="150px">
                    <span v-if="form.userManage">{{form.userManage.nickName}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="150px">
                    <span v-if="form.userInfo">{{form.userInfo.username}}</span>
                </el-form-item>
                <el-form-item label="设备名称：" label-width="150px">
                    <span v-if="form.productObj">{{form.productObj.name}}</span>
                </el-form-item>
                <el-form-item label="评价时间："  label-width="150px">
                    <span  v-if="form.created">{{ new Date(form.created).getFullYear()+'-'+(new Date(form.created).getMonth()+1)+'-'+new Date(form.created).getDate()+' '+new Date(form.created).getHours()+':'+new Date(form.created).getMinutes()+':'+new Date(form.created).getSeconds()}} </span>
                </el-form-item>
                <el-form-item label="评价内容：" label-width="150px">
                    <div>
                        <span>{{form.content}}</span>
                        <div v-if="form.photo && form.photo.length" class="img-item">
                            <img v-for="item in form.photo" :src="item" :key="item" alt="" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="评价分数："  label-width="150px">
                    <span>{{form.grade}} <small>（最高5分，最低1分）</small></span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>


        <el-dialog title="审核评论详情" :visible.sync="dialogCheckVisible" size="large">
            <el-form :model="form">
                <el-form-item label="订单号：" label-width="150px">
                    <span v-if="form.orderInfo">{{form.orderInfo.orderNo}}</span>
                </el-form-item>
                <el-form-item label="用户昵称：" label-width="150px">
                    <span v-if="form.userManage">{{form.userManage.nickName}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="150px">
                    <span v-if="form.userInfo">{{form.userInfo.username}}</span>
                </el-form-item>
                <el-form-item label="设备名称：" label-width="150px">
                    <span v-if="form.productObj">{{form.productObj.name}}</span>
                </el-form-item>
                <el-form-item label="评价时间：" label-width="150px">
                    <span v-if="form.created">{{ new Date(form.created).getFullYear()+'-'+(new Date(form.created).getMonth()+1)+'-'+new Date(form.created).getDate()+' '+new Date(form.created).getHours()+':'+new Date(form.created).getMinutes()+':'+new Date(form.created).getSeconds()}} </span>
                </el-form-item>
                <el-form-item label="评价内容：" label-width="150px">
                    <div>
                        <span>{{form.content}}</span>
                        <div v-if="form.photo && form.photo.length" class="img-item">
                            <img v-for="item in form.photo" :src="item" :key="item" alt="" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="评价分数："  label-width="150px">
                    <span>{{form.grade}} <small>（最高5分，最低1分）</small></span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handlePass">审核通过</el-button>
                <el-button type="danger" @click="handleNo">审核不通过</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getComments,
        getUsersDetail,
        getOrderDetail,
        putComments,
        deleteComments,
        filterComments,
        getProductDetailsId,
        getCommontCount,
        filterUser,
        getOrder
    } from '../../api/version'


    export default {
        data() {
            return {
                Role: sessionStorage.power,
                currentPage: 1,
                loading: true,
                totalNum: 0,
                fetchList: [],
                formInline: {
                    orderNo: '',
                    username: ''
                },
                dialogFormVisible: false,
                dialogCheckVisible: false,
                userInfo: '',
                form: {
                    orderId: '',

                },
                filter: {}

            }
        },

        created() {
            //获取所有评论列表
            this.filter = JSON.stringify({
                "order": "id desc",
                "limit": 20,
                "skip": 0,
            })
            getComments(sessionStorage.userId, this.filter).then(res => {
                res.data.forEach((item, index) => {
                    let _this = index
                    let _data = res.data
                    this.fetchList = _data

                    if (_data[_this].photo.length) {
                        _data[_this].photo.forEach((item2, index) => {
                            _data[_this].photo[index] = `https://img.shareplay.cc/${item2}`
                        })
                    }

                    //获取用户信息
                    getUsersDetail(sessionStorage.userId, item.userId).then(res => {
                        let _data = JSON.parse(JSON.stringify(this.fetchList))
                        console.log(_this, 'g')
                        _data[_this].userInfo = res.data
                        this.fetchList = _data
                    })

                    getOrderDetail(sessionStorage.userId, item.orderId).then(res => {
                        let _data = JSON.parse(JSON.stringify(this.fetchList))
                        _data[_this].orderInfo = res.data
                        this.fetchList = _data
                    })

                    getProductDetailsId(item.productDetailId).then(res => {
                        let _data = JSON.parse(JSON.stringify(this.fetchList))
                        _data[_this].productObj = res.data
                        this.fetchList = _data
                    })
                })
                this.loading = false
                console.log(this.fetchList)

            })

            getCommontCount(sessionStorage.userId, JSON.stringify({})).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })

        },

        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                let filter = JSON.parse(this.filter)
                filter.skip =  20 * (--val)
                this.filter = JSON.stringify(this.filter)
                getComments(sessionStorage.userId, filter).then(res => {
                    res.data.forEach((item, index) => {
                        let _this = index
                        let _data = res.data

                        if (_data[_this].photo.length) {
                            _data[_this].photo.forEach((item2, index) => {
                                _data[_this].photo[index] = `https://img.shareplay.cc/${item2}`
                            })
                        }

                        //获取用户信息
                        getUsersDetail(sessionStorage.userId, item.userId).then(res => {
                            _data[_this].userInfo = res.data
                            this.fetchList = _data
                        })

                        getOrderDetail(sessionStorage.userId, item.orderId).then(res => {
                            _data[_this].orderInfo = res.data
                            this.fetchList = _data
                        })

                        getProductDetailsId(item.productDetailId).then(res => {
                            _data[_this].productObj = res.data
                            this.fetchList = _data
                        })
                    })
                    console.log(this.fetchList)
                    this.loading = false
                })
            },
            handleView(index, row) {
                //查看
                this.dialogFormVisible = true
                this.form = row
            },

            handleCheck(index, row) {
                //审核
                this.dialogCheckVisible = true
                this.form = row
            },
            handlePass() {
                //审核通过
                putComments(sessionStorage.userId, this.form.id, {
                    isAllowed: true,
                    status: 1
                }).then(res => {
                    console.log(res.data)
                    if (res.data) {
                        this.$message({
                            message: '审核成功',
                            type: 'success'
                        });
                        this.fetchList.forEach(item => {
                            if (item.id === this.form.id) {
                                item.isAllowed = true
                                item.status = 1
                            }
                        })
                        this.dialogCheckVisible = false
                    }
                }, err => {
                    this.$message.error('审核失败')
                })
            },
            handleNo() {
                //审核不通过
                putComments(sessionStorage.userId, this.form.id, {
                    isAllowed: false,
                    status: 2
                }).then(res => {
                    console.log(res.data)
                    if (res.data) {
                        this.$message({
                            message: '审核成功',
                            type: 'success'
                        });
                        this.fetchList.forEach(item => {
                            if (item.id === this.form.id) {
                                item.isAllowed = false
                                item.status = 2
                            }
                        })
                        this.dialogCheckVisible = false
                    }
                }, err => {
                    this.$message.error('审核失败')
                })
            },
            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    deleteComments(sessionStorage.userId, row.id).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            this.fetchList.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            resetForm(formName) {
                this.formInline = {
                    mobile: '',
                    orderId: ''
                }
                this.$refs[formName].resetFields();
            },
            handleAdd() {
                //添加商品
                this.dialogNewVisible = true
            },
            Search() {
                //搜索

                let search = {}
                let find = []
                let orderTag = false
                let userTag = false
                if (this.formInline.orderNo) {
                    orderTag = true
                    find[0] = getOrder(sessionStorage.userId, JSON.stringify({
                        'where': {
                            'orderNo': {
                                'like': '%25' + this.formInline.orderNo + '%25'
                            }
                        }
                    }))
                }
                if (this.formInline.username) {
                    userTag = true
                    find[1] = filterUser(sessionStorage.userId, JSON.stringify({
                        'where': {
                            'username': {
                                'like': '%25' + this.formInline.username + '%25'
                            }
                        }
                    }))
                }

                Promise.all(find).then(response => {
                    console.log(response[0], 'ff')
                    if (response[0]) {
                        let res = response[0]
                        if (res.data && res.data.length) {
                            search.orderId = res.data[0].id
                        } else {
                            this.totalNum = 0
                            this.fetchList = []
                        }
                    }
                    if (response[1]) {
                        let res = response[1]
                        if (res.data && res.data.length) {
                            search.userId = res.data[0].userId
                        } else {
                            this.totalNum = 0
                            this.fetchList = []
                        }
                    }
                }).then(res => {
                    console.log(search,'search')
                    if(Object.keys(search).length==0) {
                        if(userTag || orderTag) {
                            this.$message.error('没有符合条件的评论')
                            return false
                        }else{
                            this.filter = JSON.stringify({
                                "order": "id desc",
                                "limit": 20,
                                "skip": 0,
                            })
                        }

                    }else{
                        if(userTag && !search.userId) {
                            this.$message.error('没有符合条件的评论')
                            return false
                        }
                        if(orderTag && !search.orderId) {
                            this.$message.error('没有符合条件的评论')
                            return false
                        }
                        this.filter = JSON.stringify({
                            "order": "id desc",
                            "limit": 20,
                            "skip": 0,
                            'where': search
                        })
                    }

                    getComments(sessionStorage.userId, this.filter).then(res => {
                        res.data.forEach((item, index) => {
                            let _this = index
                            let _data = res.data
                            this.fetchList = _data

                            if (_data[_this].photo.length) {
                                _data[_this].photo.forEach((item2, index) => {
                                    _data[_this].photo[index] = `https://img.shareplay.cc/${item2}`
                                })
                            }

                            //获取用户信息
                            getUsersDetail(sessionStorage.userId, item.userId).then(res => {
                                let _data = JSON.parse(JSON.stringify(this.fetchList))
                                console.log(_this, 'g')
                                _data[_this].userInfo = res.data
                                this.fetchList = _data
                            })

                            getOrderDetail(sessionStorage.userId, item.orderId).then(res => {
                                let _data = JSON.parse(JSON.stringify(this.fetchList))
                                _data[_this].orderInfo = res.data
                                this.fetchList = _data
                            })

                            getProductDetailsId(item.productDetailId).then(res => {
                                let _data = JSON.parse(JSON.stringify(this.fetchList))
                                _data[_this].productObj = res.data
                                this.fetchList = _data
                            })
                        })
                        this.loading = false
                        console.log(this.fetchList)

                    })

                    getCommontCount(sessionStorage.userId, JSON.stringify(search)).then(res => {
                        console.log(res.data)
                        this.totalNum = res.data.count
                    })
                })



            },


        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .img-item img {
        width: 200px;
        height: 200px;
        margin-right: 20px;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// CommentList.vue?1a5a3efa